module.exports = __webpack_public_path__ + "static/assets/66d7e120ed43547f249d82b31b8134ae.svg";